export enum ESize {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large'
}

export type Sizes = ESize.SMALL | ESize.MEDIUM | ESize.LARGE
